module.exports = "/fonts/gh-icons.svg?d6eda319996f78e398b746cf0509691d";